import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class PagesIncContainerService {
  public mapPageInc(page: any) {
    return {
      titulo: page.titulo ? page.titulo : '',
      subtitulo: page.subtitulo ? page.subtitulo : '',
      urlIframe: page.urlIframe ? page.urlIframe : null
    };
  }
}
